module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"file-upload\"> <div class=\"form-group\"> <div class=\"btn btn-file-container btn-sm btn-outline-secondary\"> <span>Upload</span> <input type=\"file\" class=\"read-image btn-file\" accept=\"image/*\"> </div> <span class=\"reset-image\"></span> ")
    ;  if (locals.filename) { 
    ; __append(" <div class=\"text-muted small\">")
    ; __append(escapeFn( locals.filename ))
    ; __append("</div> ")
    ;  } 
    ; __append(" </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/brand/image_upload/template.ejs
// module id = 1303
// module chunks = 1